package models

data class Wish(
    val name: String,
    val from: String,
    val message: String,
    val isShow: Boolean,
    val gift: String,
    val createdAt: Long
)